import React from 'react';
import { HtmlPortalNode } from 'react-reverse-portal';

export interface Props {
  portals: HtmlPortalNode[];
}

export const GridXAxis: React.FC<Props> = () => {
  return null;
};

export const GridYAxis: React.FC<Props> = () => {
  return null;
};
